var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.level === 1)?_c('h1',{class:(_vm.align + " " + (_vm.size ? 'size-x' + _vm.size : ''))},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")]):(_vm.level === 2)?_c('h2',{class:(_vm.align + " " + (_vm.size ? 'size-x' + _vm.size : ''))},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b6fe9a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Heading.vue
// module id = null
// module chunks = 